import { useQuery } from '@tanstack/react-query';
import { listAuditLog } from '../lib/api';
import { Card, EmptyState, ErrorBox, Loading, PageHeader, formatDate } from '../components/ui';

export function AuditLogPage(): JSX.Element {
  const q = useQuery({ queryKey: ['audit-log'], queryFn: () => listAuditLog(100) });

  if (q.isLoading) return <Loading />;
  if (q.isError) return <ErrorBox message={(q.error as Error).message} />;

  return (
    <>
      <PageHeader title="Audit log" subtitle="Every admin action, newest first." />
      {q.data!.items.length === 0 ? (
        <EmptyState>No audit entries yet.</EmptyState>
      ) : (
        <Card className="p-0">
          <table className="w-full text-sm">
            <thead className="border-b border-border text-left text-xs text-text-soft">
              <tr>
                <th className="px-4 py-2 font-medium">When</th>
                <th className="px-4 py-2 font-medium">Actor</th>
                <th className="px-4 py-2 font-medium">Action</th>
                <th className="px-4 py-2 font-medium">Target</th>
                <th className="px-4 py-2 font-medium">Details</th>
              </tr>
            </thead>
            <tbody>
              {q.data!.items.map((row) => (
                <tr key={row.id} className="border-b border-border last:border-0 align-top">
                  <td className="px-4 py-2 text-xs text-text-soft">{formatDate(row.createdAt)}</td>
                  <td className="px-4 py-2 text-xs">{row.actorEmail ?? '—'}</td>
                  <td className="px-4 py-2 font-medium">{row.action}</td>
                  <td className="px-4 py-2 font-mono text-xs">
                    {row.targetType && row.targetId
                      ? `${row.targetType}/${row.targetId.slice(0, 14)}`
                      : '—'}
                  </td>
                  <td className="px-4 py-2 text-xs text-text-soft">
                    {row.details ? (
                      <pre className="max-w-md overflow-x-auto">{row.details}</pre>
                    ) : (
                      '—'
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </>
  );
}
